import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-download-charts-pdf-snackbar',
    template: `
    <section class="relative w-auto h-auto bg-none block z-auto">
      <div
        class="bg-gray-100/90 w-fit h-fit min-w-[18rem] max-w-xs rounded-lg shadow-md border border-gray-200 overflow-hidden"
      >
        <div
          class="bg-gray-50 p-4 text-left h-full w-full flex items-center gap-3 animate-pulse"
        >
          <div class="m-0 flex justify-center flex-shrink-0">
            <mat-spinner [diameter]="24" color="primary"></mat-spinner>
          </div>
          <div class="flex-1">
            <h3
              class="m-0 mb-1 text-sm font-semibold text-blue-900 leading-tight"
            >
              {{ message }}
            </h3>
            <p class="m-0 text-xs text-gray-600 leading-tight">
              {{ details }}
            </p>
          </div>
        </div>
      </div>
    </section>
  `,
    standalone: false
})
export class DownloadChartsPdfSnackbarComponent {
  @Input() message = 'Generating Operations PDF...';

  @Input() details = 'Processing Charts...';
}
